import { useIsGuest, useIsLicensed, useSessionData } from '@confluence/session-data';

export type FetchUsersClient = 'agg' | 'ccgraphql';

/**
 * Used to help determine if {@link fetchNativeCollabAGGUsers} or {@link fetchNativeCollabConfluenceUsers} should be used
 * Non licensed users (anonymous, JSM users, or guests) shouldn't make the query call in fetchNativeCollabConfluenceUsers
 * since viewing profile permissions are guarded
 */
export const useFetchUsersClient = (): { client: FetchUsersClient } => {
	const { isLoggedIn } = useSessionData();
	const isLicensed = useIsLicensed();
	const isGuest = useIsGuest();

	const client = isGuest || !isLoggedIn || !isLicensed ? 'agg' : 'ccgraphql';

	return { client };
};
